import React,{useState,useContext} from 'react';
import Modal from '../Settings/Modal';
import { SettingModal, useSettingModal } from '../../../hooks/Context';
import styled from '@emotion/styled';
import { TopDisplay,Button,UploadButton } from '../../../ui-components';
import { BatchInvites } from './Modal';
import apiCall from '../../../utils/apiCall';
import fileDownload from 'js-file-download';
import { NotificationContext } from '../../../providers/notification';
import DisplayTrainingInvites from './DisplayTrainingInvites';
import apiCallFormData from '../../../utils/apiFormDataCall';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ExNyRoute,PrRoute, ExRoute, AcRoute, MiRoute,  CoRoute } from '../../../utils/allRouteId';

const option1:any= [
  {val:ExNyRoute, name:"Examination / NYSC",path:``},
  {val:PrRoute, name:"Practitioner",path:`practitioner`},
  {val:ExRoute, name:"Executive",path:`executive`},
  {val:AcRoute, name:"Academic",path:`academic`},
  {val:MiRoute, name:"Military",path:`military`},
  {val:CoRoute, name:"Corporate",path:`corporate`}
]
export default function TrainingInvites() {

  const [route, setRoute] = useState<{name: string, val: number}>({name: 'Examination / NYSC', val: Number(ExNyRoute)})
  const [openBatchInviteModal, setOpenBatchInviteModal] = useState(false);


  const handleOpenBatchInvite = () => {
    setOpenBatchInviteModal(true)
  }

  const handleCloseBatchInvite = () => {
    setOpenBatchInviteModal(false)
  }

  return (

      <SettingModal>
        <ViewWrapper>
                <TopDisplay subTitle={`All Pending / Awaiting Invites` }title="Training-Invites" Btn={<TopBtns handleOpenBatchInvite= {handleOpenBatchInvite} id={route?.val}/>} />
                <DisplayTrainingInvites showBatchInviteModal= {openBatchInviteModal} handleCloseBatchInvite = {handleCloseBatchInvite} route= {route} setRoute = {setRoute}/>
        </ViewWrapper>
        <Modal />
      </SettingModal>
  )
}

 const TopBtns = (props:any)=>{
  const {setModalContent,setShowModal} = useSettingModal();
  const {showNotification} = useContext(NotificationContext);
  const [d_loading,set_d_loading] = useState<boolean>(false);
  const [u_loading,set_u_loading] = useState<boolean>(false);

  const routeId = props.id || 1;
  const handleOpenBatchInvite = props.handleOpenBatchInvite

  const handleInviteBatch = () =>{
    //setModalContent(<BatchInvites />)
    handleOpenBatchInvite()
  }
  

  const downloadApplicantPendingTraining = async () => {
    return await (apiCall().get(`/Activity/DownloadPendingTraining?routeId=${routeId}&activity=Training`, {responseType: 'blob'}))
  }

  const { data, isSuccess, error, refetch, isLoading, isFetching } = useQuery(['download-applicant-pending-training', routeId], downloadApplicantPendingTraining, {
    retry: 0,
    keepPreviousData: true,
    enabled: false,
  });

  const downloadApplicantPendingTrainingError = error as AxiosError;
  const downloadApplicantPendingTrainingErrorMessage = downloadApplicantPendingTrainingError?.message;

  const handleDownloadPendingApplicant = async () => {
    
    await refetch().then((data: any) => {
      if(!data) return

      const blob =  new Blob([data?.data?.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'traininglist.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch((error: any) => {
      showNotification({
        type: 'error',
        message: 'No record found for download',
      })
    })
    
  };

  const uploadTrainingAttendant = async(data: FormData) => {
    return await(apiCallFormData().post('/Activity/UploadTrainingAttendant', data));
  }

  const uploadTrainingAttendantMutation = useMutation(['upload-training-attendant'], uploadTrainingAttendant, {retry: 0});
  
  const handleUpload =  async (e:any) => {
    let file = e.target.files[0];
    let activity = "Training";

    const body = new FormData();
    body.append('RouteId', routeId);
    body.append('Activity', activity);
    body.append('Trainee', file);

    set_u_loading(true);
    try {
      await uploadTrainingAttendantMutation.mutateAsync(body, {
        onSuccess: () => {
          showNotification({
            message:'file uploaded successfully',
            type:'success'
          })
          set_u_loading(false);
        },
        onError: () => {
          set_u_loading(false);
        }
      })
      
    } catch (error: any) {
      showNotification({
        message: error?.response?.data?.Message || error?.message || 'file not uploaded ',
        type:'error'
      })
    }
    e.target.value = ''
  }

  return (<div style={{display:'flex',gap:'10px'}}>
    <UploadButton onChange={handleUpload} label={!u_loading?"Upload Training List":'Loading Upload...' }/>

    <Button onClick={handleDownloadPendingApplicant} children={!isFetching ? 'Download Training Template' : 'Downloading...'} border="#E2E4E9" bg="#E2E4E9" color="#11643C"/>
    <Button onClick={handleInviteBatch} children={'Batch Invite'}  />

  </div>)
}

const ViewWrapper = styled.div`
  width: 100%;
  padding:0 48px 48px;
`
